import React, { useState, useEffect } from 'react';
import PersonalInfo from '../Assets/images/personal information.png';
import DoneIcon from '@mui/icons-material/Done';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import outerCircle from '../Assets/images/vector.png';
import { getUserAcc, getUserDetails } from '../Auth/AuthUtil';
import { useNavigate } from 'react-router-dom';
import Cookies from 'universal-cookie';
import Lottie from 'lottie-react';
import WelcomeScreenanimation from '../Assets/animations/welcomscreenrotation.json';
import { profileModel } from '../Axios/AxiosConfig';
import maleicon from '../Assets/images/maleicon (2).png'
import femaleicon from '../Assets/images/femaleicon (1).png'
import othericon from '../Assets/images/othersicon.png'
import vikritinext from '../Assets/images/vikritinext.png'

function Profile() {
  const genderOptions = ["Male", "Female", "Other"];
  const foodprefernces = ["Vegetarian", "Non-Vegetarian", "Vegan"]

  const userDetails = getUserAcc()

  const navigate = useNavigate()

  const cookies = new Cookies();

  const indianLanguages = [
    "Assamese", "Bengali", "Bodo", "Dogri", "Gujarati", "Hindi", "Kannada", "Kashmiri", "Konkani",
    "Maithili", "Malayalam", "Manipuri", "Marathi", "Nepali", "Odia", "Punjabi", "Sanskrit", "Santali",
    "Sindhi", "Tamil", "Telugu", "Urdu"
  ];

  const [formData, setFormData] = useState({
    gender: '',
    motherTongue: '',
    dob: '',
    name: '',
    foodpreference: '',
    heightFeet: '',
    heightInches: '',
    weight: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevState) => ({
      ...prevState,
      [name]: name === 'dob' ? value.split('-').reverse().join('/') : value,
    }));


    setFormErrors((prevErrors) => ({
      ...prevErrors,
      [name]: undefined,
    }));
  };


  const [fieldsCompleted, setFieldsCompleted] = useState(0);

  const isCompleted = () => {
    return fieldsCompleted === 5
  }

  function extractName(fullName) {
    const nameParts = fullName.trim().split(' ');
    const lastName = nameParts.pop();
    const firstName = nameParts.join(' ');
    return { firstName, lastName };
  }


  const [formErrors, setFormErrors] = useState({});



  const SubmitProfile = async () => {
    const errors = {};

    if (!formData.name || formData.name.trim() === '') {
      errors.name = 'Name is required';
    }
    if (!formData.gender) {
      errors.gender = 'Gender is required';
    }
    if (!formData.dob) {
      errors.dob = 'Date of birth is required';
    }

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }

    try {
      const { firstName, lastName } = extractName(formData.name);

      let res = await profileModel.post('/Profile', {
        UID: getUserDetails()?.UID,
        gender: formData?.gender,
        dob: formData?.dob,
        foodpreference: formData?.foodpreference,
        mothertounge: formData?.motherTongue,
        weight: formData?.weight ? `${formData.weight} Kg` : 'N/A',
        height:
          formData?.heightFeet || formData?.heightInches
            ? `${formData.heightFeet || 0} feet ${formData.heightInches || 0} inches`
            : 'N/A',
        firstname: firstName,
        lastname: lastName || '',
        src: ''
      });

      if (res.status === 200) {
        cookies.remove('UserDetails');
        navigate('/Onboarding');
      }
    } catch (err) {
      console.log(err);
    }
  };


  // const circumference = 2 * Math.PI * 50;
  // const progress = (fieldsCompleted / 7) * 100;
  // const offset = circumference - (progress / 100) * circumference;

  // useEffect(() => {
  //   const fields = [formData?.gender, formData?.motherTongue, formData?.heightFeet, formData?.weight, formData?.dob];
  //   const count = fields.filter(field => field?.trim() !== '')?.length;

  //   setFieldsCompleted(count);
  // }, [formData?.gender, formData?.motherTongue, formData?.heightFeet, formData?.weight, formData?.dob]);

  // const fields = [formData?.gender, formData?.motherTongue, formData?.heightFeet, formData?.weight, formData?.dob];

  return (
    <div className='Symptoms-page-section flex flex-col gap-2 justify-center items-center'>

      <div className='Profile-main-section '>

        <div className="Welcome-section-animation">
          <Lottie animationData={WelcomeScreenanimation} />
        </div>

        <div className='Profile-heading-section text-center'>
          <p>Hello there!</p>
          <p>Welcome on board! Share a few details for a personalized experience</p>
        </div>

        <div className="Profile-input-container w-full max-w-md">

          <label>
            Name <span className="text-red-500">*</span>
          </label>

          <input
            type="text"
            name="name"
            value={formData?.name}
            onChange={handleChange}
            className={`w-full px-3 py-2 border rounded-md focus:outline-none ${formErrors.name ? 'border-red-500' : 'border-gray-300'
              }`}
          />

          {formErrors?.name && (
            <p className="text-red-500 text-sm mt-1">{formErrors?.name}</p>
          )}

        </div>

        <div className="Profile-input-container w-full max-w-md">

          <label>
            Gender <span className="text-red-500">*</span>
          </label>

          <div className="flex items-center justify-between">
            {[
              { label: "Male", icon: maleicon },
              { label: "Female", icon: femaleicon },
              { label: "Others", icon: othericon }
            ].map((gender) => (
              <div
                key={gender?.label}
                className={`genderoptioncard flex flex-col items-center gap-2 cursor-pointer`}
                onClick={() =>
                  handleChange({ target: { name: "gender", value: gender?.label } })
                }
              >
                <div className={`${formData?.gender === gender?.label ? 'border border-[#DA6E0B] rounded-md p-1' : ''}`}>
                  <img src={gender?.icon} alt={gender?.label} />
                </div>
                <p>{gender?.label}</p>
              </div>
            ))}

          </div>

          {formErrors?.gender && (
            <p className="text-red-500 text-sm mt-1">{formErrors?.gender}</p>
          )}

        </div>

        <div className="Profile-input-container w-full max-w-md">

          <label>
            Date of Birth <span className="text-red-500">*</span>
          </label>

          <input
            type="date"
            name="dob"
            value={formData?.dob ? formData?.dob?.split('/')?.reverse()?.join('-') : ''}
            onChange={handleChange}
            max={new Date(new Date().setFullYear(new Date().getFullYear() - 18))
              .toISOString()
              .split('T')[0]}
            className={`w-full px-3 py-2 border rounded-md focus:outline-none ${formErrors.dob ? 'border-red-500' : 'border-gray-300'
              }`}
          />

          {formErrors?.dob && (
            <p className="text-red-500 text-sm mt-1">{formErrors?.dob}</p>
          )}

        </div>

        {/* <div className="Profile-input-container">
          <label>Mother Tongue</label>
          <input
            list="mother-tongue-options"
            name="motherTongue"
            value={formData.motherTongue}
            onChange={handleChange}
          />
          <datalist id="mother-tongue-options">
            {indianLanguages.map((option, index) => (
              <option key={index} value={option} />
            ))}
          </datalist>
        </div>

        <div className="Profile-input-container">
          <label>Height</label>
          <div style={{ display: 'flex', gap: '10px' }}>

            <input
              type="number"
              name="heightFeet"
              value={formData.heightFeet || ''}
              onChange={(e) =>
                setFormData((prevState) => ({
                  ...prevState,
                  heightFeet: e.target.value,
                }))
              }
              placeholder="Feet"
              min="0"
            />

            <input
              type="number"
              name="heightInches"
              value={formData.heightInches || ''}
              onChange={(e) =>
                setFormData((prevState) => ({
                  ...prevState,
                  heightInches: e.target.value,
                }))
              }
              placeholder="Inches"
              min="0"
              max="11"
            />
          </div>
        </div>

        <div className="Profile-input-container">
          <label>Weight</label>
          <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            <input
              type="number"
              name="weight"
              value={formData.weight || ''}
              onChange={(e) =>
                setFormData((prevState) => ({
                  ...prevState,
                  weight: e.target.value,
                }))
              }
              placeholder="Weight"
              min="0"
            />
            <span>Kg</span>
          </div>
        </div>

        <div className="Profile-input-container">
          <label>Food Preferences</label>

          <input
            list="foodpreference-options"
            name="foodpreference"
            value={formData.foodpreference}
            onChange={handleChange}
          />

          <datalist id="foodpreference-options">
            {foodprefernces.map((option, index) => (
              <option key={index} value={option} />
            ))}
          </datalist>
        </div> */}

        <div className='mt-5' onClick={() => {
          SubmitProfile()
        }} style={{ alignSelf: "center", justifySelf: "flex-end", marginTop: "auto", width: "3rem", cursor: "pointer" }} >
          <img src={vikritinext}></img>
        </div>

      </div>
    </div>
  );
}

export default Profile;
